var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "disabled": !_vm.src,
      "content-class": "black"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        }), !_vm.hideActivator ? _c('v-avatar', _vm._g(_vm._b({
          style: !_vm.src ? 'cursor:initial' : '',
          attrs: {
            "rounded": "0"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              $event.stopPropagation();
            }
          }
        }, 'v-avatar', Object.assign({}, attrs, _vm.attrs_avatar), false), on), [_vm.isPDF ? [_c('embed', _vm._b({
          staticClass: "fill-height",
          staticStyle: {
            "pointer-events": "none"
          },
          attrs: {
            "type": "application/pdf"
          }
        }, 'embed', {
          src: _vm.src
        }, false))] : [_c('v-img', _vm._b({
          attrs: {
            "src": _vm.src,
            "alt": ""
          },
          scopedSlots: _vm._u([{
            key: "placeholder",
            fn: function () {
              return [_c('v-overlay', {
                attrs: {
                  "absolute": "",
                  "opacity": "0.1"
                }
              }, [_c('v-icon', [_vm._v("mdi-image-broken-variant")])], 1)];
            },
            proxy: true
          }], null, true)
        }, 'v-img', _vm.$attrs, false))]], 2) : _vm._e()];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.src ? [_c('v-card', {
    staticClass: "fill-height d-flex flex-column",
    attrs: {
      "dark": "",
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-title', [_vm._v(" 미리보기 "), _c('v-spacer'), _c('v-btn', {
    staticClass: "transparent ma-n1",
    attrs: {
      "icon": "",
      "tile": ""
    },
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm.isPDF ? [_c('embed', _vm._b({
    attrs: {
      "type": "application/pdf",
      "width": "100%",
      "height": "100%"
    }
  }, 'embed', {
    src: _vm.src
  }, false))] : [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.src,
      "contain": "",
      "max-width": "85vh",
      "max-height": "85vh"
    }
  })], 1)]], 2)], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }